import type * as lazyIndex from "./lazyIndex";
import { LazyModule, registerLazyOrchestrator } from "owa-bundling";
import { initializeTodayWebDocumentHost } from "owa-personal-os-public-actions";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "TodayMailDocumentHost" */ "./lazyIndex"), { name: "TodayMailDocumentHost" });
let registered = false;

export function registerTodayMailDocumentHost(): void {
    if (registered) {
        return;
    }
    registerLazyOrchestrator(initializeTodayWebDocumentHost, lazyModule, module => module.initializeTodayWebDocumentHostOrchestrator);
    registered = true;
}
